import React from 'react';
import Marker from 'Utils/Marker';
import classnames from 'classnames';
import Accordion from 'Utils/Accordion';

const Directions = (props) => {
  const { directions, truck, stops } = props;

  // This component is print-only (no interactive usage exists), so it doesn't need
  // ScrollArea's fixed-height, JS-scrolled panel — that library measures/positions
  // its content via an inline `height: 100%` child inside an auto-height parent,
  // which collapses to 0px with nothing to scroll within; print then ignores the
  // resulting overflow clipping and paints the content anyway, on top of whatever
  // else occupies that page position (here, the map above it) — see TD1-7659. A
  // plain wrapper (same `.scrollarea`/`.scrollarea-content` classnames, so existing
  // CSS still applies) just lets it flow normally.
  return (
    <div className='scrollarea'>
      <div className='scrollarea-content'>
        {directions && (
          <ul className='directions printDirectionAccordionBtn'>
            {directions.legs.map((leg, legIndex) => {
              if (leg.start_address !== leg.end_address) {
                return (
                  <Accordion
                    key={legIndex}
                    header={
                      <div className='start '>
                        <Marker
                          type={
                            stops[legIndex]?.stopType === 'standard'
                              ? 'route'
                              : 'stop'
                          }
                          text={legIndex}
                          truck={truck}
                          stopId={stops[legIndex]?.id}
                          transportType={
                            stops[legIndex]?.stopType === 'standard'
                              ? stops[legIndex]?.rentalTransport?.transportType
                              : null
                          }
                        />
                        {legIndex === 0 ? 'Get on' : 'Follow'}{' '}
                        {leg.start_address}
                      </div>
                    }
                    content={
                      <li key={legIndex}>
                        <div>
                          <div>
                            <ul>
                              {leg.steps.map((step, stepIndex) => (
                                <div>
                                  <hr />
                                  <li key={stepIndex}>
                                    <div
                                      className={classnames({
                                        icon: true,
                                        [step.maneuver]: step.maneuver,
                                        noManeuver:
                                          !step.maneuver ||
                                          step.maneuver === '',
                                      })}
                                    />
                                    <div
                                      className='editedText'
                                      dangerouslySetInnerHTML={{
                                        __html: step.instructions
                                          ? step.instructions
                                          : '',
                                      }}
                                    />
                                    <div className='details'>
                                      {step.distance.text}
                                    </div>
                                  </li>
                                </div>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </li>
                    }
                  />
                );
              } else {
                return null;
              }
            })}
            <div className='directionsInstructions'>
              These directions are for planning purposes only. You may find that
              construction projects, traffic, weather, or other events may cause
              conditions to differ from the map results, and you should plan
              your route accordingly. You must obey all signs or notices
              regarding your route.
            </div>
          </ul>
        )}
      </div>
    </div>
  );
};

export default Directions;
